import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { QuestionSectionComponentProps } from './types';

export const QuestionGeneratedSection: FC<
  QuestionSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
